import { SpinnerMonoIndicators as Spinner } from '@clearkit/icons';
import { FC } from 'react';
import { Redirect } from 'react-router';

import AuthLayout from '~/components/layouts/AuthLayout';

import CreateAccount from './CreateAccount';
import ListOrganizations from './ListOrganizations';
import useDiscovery from './useDiscovery';

export type StytchTokenType = 'discovery' | 'discover_oauth';

const AuthDiscovery: FC = function() {
  const { data, isLoading } = useDiscovery();

  if (isLoading || !data) {
    return (
      <AuthLayout>
        <Spinner className="w-10 h-10 text-blue-500" />
      </AuthLayout>
    );
  }

  if (data.action === 'unauthorized') {
    return <Redirect to={`/auth/login?error=${data.type}`} />;
  }

  return (
    <AuthLayout>
      {data.action === 'create_account' ? (
        <CreateAccount proposedOrg={data.proposed_account} />
      ) : null}
      {data.action === 'discover' ? (
        <ListOrganizations accounts={data.discovered_accounts} />
      ) : null}
    </AuthLayout>
  );
};

export default AuthDiscovery;
